import { render, staticRenderFns } from "./message.vue?vue&type=template&id=0aad36ea&lang=html&"
import script from "./message.vue?vue&type=script&lang=js&"
export * from "./message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Devdoc\\_packages\\moss-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0aad36ea')) {
      api.createRecord('0aad36ea', component.options)
    } else {
      api.reload('0aad36ea', component.options)
    }
    module.hot.accept("./message.vue?vue&type=template&id=0aad36ea&lang=html&", function () {
      api.rerender('0aad36ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/message.vue"
export default component.exports